import React, { useState } from "react";
import { Plus, FileText, Calendar, UserPlus, ClipboardList, X } from "lucide-react";

export default function QuickAdd({ onNavigate }) {
  const [open, setOpen] = useState(false);

  const actions = [
    { label: "New Note", icon: FileText, to: "/notes" },
    { label: "New Client", icon: UserPlus, to: "/clients" },
    { label: "Schedule", icon: Calendar, to: "/scheduling" },
    { label: "Treatment Plan", icon: ClipboardList, to: "/treatment-plans" },
  ];

  return (
    <div className={`md:hidden fixed right-5 cw-fab-quick ${open ? "z-50" : "z-30"}`}>
      {open && (
        <div className="absolute bottom-16 right-0 flex flex-col gap-2 items-end">
          {actions.map((a, i) => (
            <button
              key={a.to}
              onClick={() => { onNavigate(a.to); setOpen(false); }}
              className="flex items-center gap-2 px-4 py-2.5 rounded-full shadow-lg mf-fade-in whitespace-nowrap"
              style={{ background: "var(--mf-surface)", color: "var(--mf-text)", animationDelay: `${i * 0.05}s` }}
              data-testid={`quick-add-${a.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <a.icon className="w-4 h-4" style={{ color: "var(--mf-primary)" }} strokeWidth={1.75} />
              <span className="text-sm font-medium">{a.label}</span>
            </button>
          ))}
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-transform hover:scale-105"
        style={{ background: "var(--mf-accent)" }}
        data-testid="quick-add-fab"
        aria-label="Quick add"
      >
        {open ? <X className="w-6 h-6 text-white" /> : <Plus className="w-6 h-6 text-white" />}
      </button>
    </div>
  );
}
